export const staff = {
  'staff.title': 'الموظفون',
  'staff.subtitle': 'العقود والمخصصات والغياب',
  'staff.new': 'موظف جديد',
  'staff.search': 'ابحث بالاسم أو المسمى الوظيفي',
  'staff.filter': 'حالة الموظف',
  'staff.status.ACTIVE': 'على رأس العمل',
  'staff.status.LEFT': 'ترك العمل',
  'staff.col.name': 'الموظف',
  'staff.col.phone': 'الهاتف',
  'staff.col.base': 'الراتب الأساسي',
  'staff.col.allowances': 'المخصصات',
  'staff.col.advances': 'السُّلف المفتوحة',
  'staff.col.account': 'حساب التطبيق',
  'staff.account.yes': 'له حساب',
  'staff.account.no': 'بلا حساب',
  'staff.empty': 'لا يوجد موظفون بعد',
  'staff.emptyBody': 'أضف الموظفين مع عقودهم ومخصصاتهم ليظهروا في مسيّر الرواتب.',
  'staff.emptySearch': 'لا يوجد موظف مطابق',
  'staff.noContract': 'بلا عقد ساري',
  'staff.perLesson': '{rate} للحصة',
  'staff.payType.MONTHLY': 'راتب شهري',
  'staff.payType.PER_LESSON': 'أجر بالحصة',
  'staff.allowance.TRANSPORT': 'مخصصات نقل',
  'staff.allowance.HOUSING': 'مخصصات سكن',
  'staff.allowance.FOOD': 'مخصصات طعام',
  'staff.allowance.FAMILY': 'مخصصات عائلية',
  'staff.allowance.POSITION': 'مخصصات منصب',
  'staff.allowance.OTHER': 'مخصصات أخرى',
  'staff.form.name': 'الاسم الكامل',
  'staff.form.phone': 'رقم الهاتف',
  'staff.form.phoneHint': 'مطلوب لإنشاء حساب في التطبيق',
  'staff.form.jobTitle': 'المسمى الوظيفي',
  'staff.form.hireDate': 'تاريخ التعيين',
  'staff.form.contract': 'العقد',
  'staff.form.payType': 'نوع الأجر',
  'staff.form.baseSalary': 'الراتب الأساسي الشهري',
  'staff.form.lessonRate': 'أجر الحصة',
  'staff.form.startDate': 'تاريخ بدء العقد',
  'staff.form.startDateHint': 'افتراضياً تاريخ التعيين',
  'staff.form.allowances': 'المخصصات الشهرية',
  'staff.form.addAllowance': 'إضافة مخصص',
  'staff.form.allowanceType': 'النوع',
  'staff.form.allowanceLabel': 'الوصف',
  'staff.form.allowanceAmount': 'المبلغ الشهري',
  'staff.form.removeAllowance': 'حذف المخصص',
  'staff.form.account': 'حساب في تطبيق تباشير',
  'staff.form.accountNone': 'بلا حساب',
  'staff.form.accountHint': 'يرى الموظف قسيمة راتبه ورصيد سلفته في التطبيق ويستطيع طلب سلفة.',
  'staff.form.created': 'أُضيف الموظف',
  'staff.form.phoneRequired': 'رقم الهاتف مطلوب لإنشاء حساب',
  'staff.detail.hired': 'عُيّن في {date}',
  'staff.detail.leftOn': 'ترك العمل في {date}',
  'staff.detail.edit': 'تعديل البيانات',
  'staff.detail.updated': 'حُفظت البيانات',
  'staff.detail.wage': 'الأجر الشهري الحالي',
  'staff.detail.contracts': 'العقود',
  'staff.detail.newContract': 'عقد جديد أو زيادة',
  'staff.detail.current': 'الساري',
  'staff.detail.period': 'المدة',
  'staff.detail.openEnded': 'مستمر',
  'staff.detail.contractHint': 'ينتهي العقد الحالي في اليوم السابق لتاريخ البدء، ويبقى القديم في السجل.',
  'staff.detail.contractSaved': 'سُجّل العقد الجديد',
  'staff.detail.noContracts': 'لا عقود',
  'staff.detail.allowances': 'المخصصات',
  'staff.detail.addAllowance': 'إضافة مخصص',
  'staff.detail.allowanceStart': 'يبدأ من',
  'staff.detail.endAllowance': 'إيقاف',
  'staff.detail.endAllowanceTitle': 'إيقاف المخصص',
  'staff.detail.endDate': 'آخر يوم للمخصص',
  'staff.detail.allowanceSaved': 'حُفظ المخصص',
  'staff.detail.allowanceEnded': 'أُوقف المخصص',
  'staff.detail.ended': 'منتهٍ',
  'staff.detail.noAllowances': 'لا مخصصات',
  'staff.detail.deductions': 'الغياب والعقوبات',
  'staff.detail.addDeduction': 'إضافة غياب أو عقوبة',
  'staff.detail.noDeductions': 'لا غياب ولا عقوبات في هذا الشهر',
  'staff.detail.deductionType.ABSENCE': 'غياب',
  'staff.detail.deductionType.PENALTY': 'عقوبة مالية',
  'staff.detail.days': 'عدد الأيام',
  'staff.detail.daysValue': '{n}',
  'staff.detail.daysHint': 'يُقبل نصف يوم، مثل {example}. يُحسب الخصم من الراتب الأساسي.',
  'staff.detail.daysInvalid': 'أدخل عدد أيام صحيحاً (نصف يوم مسموح)',
  'staff.detail.deductionSaved': 'سُجّل الاستقطاع',
  'staff.detail.deductionRemoved': 'حُذف الاستقطاع',
  'staff.detail.removeDeduction': 'حذف',
  'staff.detail.removeDeductionTitle': 'حذف هذا الاستقطاع؟',
  'staff.detail.removeDeductionBody': 'يُحذف من مسيّر الشهر عند إعادة الاحتساب.',
  'staff.detail.advances': 'السُّلف',
  'staff.detail.requestAdvance': 'طلب سلفة',
  'staff.detail.noAdvances': 'لا سُلف لهذا الموظف',
  'staff.detail.leave': 'تسجيل ترك العمل',
  'staff.detail.leaveBody': 'ينتهي العقد في هذا التاريخ ويُلغى حساب التطبيق. السُّلف المفتوحة تُسوّى نقداً أو تُشطب بموافقة المالك.',
  'staff.detail.leaveDate': 'آخر يوم عمل',
  'staff.detail.leaveDone': 'سُجّل ترك العمل',
  'staff.detail.openAdvancesWarn': 'لديه سُلف مفتوحة متبقٍ منها {amount}.',
  'staff.detail.leftNotice': 'ترك هذا الموظف العمل؛ البيانات للاطلاع فقط.',
  'staff.import': 'استيراد من Excel',
  'staff.import.title': 'استيراد الموظفين من Excel',
  'staff.import.intro': 'سطر لكل موظف. الأعمدة الإلزامية: الاسم، المسمى الوظيفي، الراتب الأساسي. يُنشأ حساب في التطبيق لكل من له رقم هاتف: معلّم إذا بدأ مسماه الوظيفي بـ«مدرّس» أو «معلّم»، وإلا موظف؛ اكتب «لا» في «حساب التطبيق» لمن لا يحتاجه. للسلفة التي ما زالت تُستقطع: المتبقي منها وقسطها الشهري.',
  'staff.import.firstMonth': 'أول شهر رواتب في تباشير',
  'staff.import.firstMonthHint': 'منه تُستقطع السلف القائمة. ومن لم يُذكر تاريخ تعيينه يُعيَّن من اليوم، أو من أول هذا الشهر إن كان قد بدأ.',
  'staff.import.accounts': 'حسابات التطبيق: {teachers} للمعلمين و{staff} للموظفين.',
  'staff.import.monthlyPay': 'مجموع الرواتب الشهرية مع المخصصات: {amount}.',
  'staff.import.advances': 'سلف قائمة: {n} بمجموع {amount}، تُستقطع من رواتب {month}.',
  'staff.import.viewStaff': 'عرض الموظفين',
  'staff.import.issue.phoneTaken': 'الرقم مسجّل لموظف آخر',
  'staff.import.issue.nameTaken': 'يوجد موظف بهذا الاسم',
  'staff.import.issue.phoneForAccount': 'الحساب في التطبيق يحتاج رقم هاتف',
  'staff.import.issue.advanceRole': 'السلف القائمة يُدخلها المدير',
  'staff.import.issue.advanceManager': 'سلفة المدير يُدخلها المالك',
  'staff.import.issue.advanceOff': 'السلف غير مفعّلة في المدرسة',
  'staff.import.issue.noRoom': 'الراتب لا يترك مجالاً للاستقطاع ضمن الحد القانوني',
  'staff.import.issue.aboveCap': 'القسط أعلى من الحد القانوني؛ الأقصى {max}',
  'staff.import.issue.tooLong': 'السداد يستغرق أكثر من {n}',
  'staff.field.name': 'الاسم',
  'staff.field.phone': 'رقم الهاتف',
  'staff.field.jobTitle': 'المسمى الوظيفي',
  'staff.field.hireDate': 'تاريخ التعيين',
  'staff.field.account': 'حساب التطبيق',
  'staff.field.payType': 'نوع الأجر',
  'staff.field.baseSalary': 'الراتب الأساسي',
  'staff.field.lessonRate': 'أجر الحصة',
  'staff.field.allowanceTransport': 'مخصصات النقل',
  'staff.field.allowanceHousing': 'مخصصات السكن',
  'staff.field.allowanceFood': 'مخصصات الطعام',
  'staff.field.allowanceFamily': 'المخصصات العائلية',
  'staff.field.allowancePosition': 'مخصصات المنصب',
  'staff.field.allowanceOther': 'مخصصات أخرى',
  'staff.field.advanceBalance': 'المتبقي من السلفة',
  'staff.field.advanceMonthly': 'قسط السلفة الشهري',
  'staff.field.advanceNote': 'ملاحظة السلفة',
} as const;
